export enum EMMA_ROLES {
  SUPER_ADMIN = 0,
  CLIENT = 1,
  AGENCY = 2,
  PROVIDER = 3,
  ADMIN = 4,
  EAT_OUT = 5,
  NOPAID = 6,
  AUTHOR = 77,
  MANAGER = 78,
  ANALYST = 79,
  GUEST_ADMIN = 80,
}

export enum LEGACY_EMMA_ROLE_NAME {
  ADMIN = 'Admin',
  AGENCY = 'Agency',
  ANALYST = 'Analyst',
  AUTHOR = 'Author',
  CLIENT = 'Client',
  CLIENT_P_MANAGER = 'Client P. manager',
  MANAGER = 'Manager',
  PROVIDER = 'Provider',
}

export const USER_MODE_ROLES = Object.freeze({
  AUTHOR: Object.freeze([LEGACY_EMMA_ROLE_NAME.AUTHOR, LEGACY_EMMA_ROLE_NAME.CLIENT]),
  MANAGER: Object.freeze([LEGACY_EMMA_ROLE_NAME.MANAGER, LEGACY_EMMA_ROLE_NAME.ADMIN]),
  ANALYST: Object.freeze([LEGACY_EMMA_ROLE_NAME.ANALYST]),
});
